/**
 * PaymentType vs PaymentVendor
 * PaymentType matches backend's payment processor name
 * PaymentVendor is a frontend enum
 */
export enum PaymentType {
  Affirm = 'affirm',
  AfterPay = 'afterpay',
  Alipay = 'alipay',
  ApplePay = 'applePay',
  CreditCard = 'card',
  Giropay = 'giropay',
  GooglePay = 'googlePay',
  Klarna = 'klarna',
  PayPal = 'paypal_v2',
  Stripe = 'stripe',
}
